import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Button } from "@mui/material";
import { SIGN_UP } from "../../constants/string";
import LoginRedirect from "./LoginRedirect";
import { makeStyles } from "@mui/styles";
import OndcExplainer from "./../../assets/OndcExplainer.png";
const useStyles = makeStyles({
  heading: {
    marginBottom: "16px !important",
    textAlign: "center",
    fontWeight: "normal",
    color: "#333",
    fontSize: "1.6rem !important",
  },
  intro: {
    mt: "8px !important",
    textAlign: "center ",
    fontSize: "1.15rem !important",
    color: "#000000 !important",
    lineHeight: "27.6px !important",
    marginBottom: "8px !important",
    paddingLeft: "16px !important",
    paddingRight: "16px !important",
    fontFamily: '"Lato", serif !important',
  },
  button: {
    marginTop: "24px !important ",
    height: "46px ",
    width: "160px !important",
    fontSize: "19.2px !important",
    padding: "16px ",
    borderRadius: "8px !important",
    backgroundColor: "#3f51b5 !important",
  },
});

const Intro = ({ setPage }) => {
  const classes = useStyles();
  const handleNextPage = () => {
    setPage(2);
  };
  return (
    <>
      <img
        src={OndcExplainer}
        style={{
          width: "100%",
          height: "auto",
          objectFit: "cover",
        }}
      />
      <Button
        variant="contained"
        fullWidth
        onClick={handleNextPage}
        className={classes.button}
        sx={{ textAlign: "center" }}
        endIcon={<ArrowForwardIcon />}
      >
        {SIGN_UP}
      </Button>

      <LoginRedirect />
    </>
  );
};
export default Intro;